import React, { useState, useEffect } from 'react';
import TemplateEditor from './wysiwyg';
import {
    Button
} from 'reactstrap';
import Modal from 'react-bootstrap/Modal'
import { sendMailApi, trackMailApi } from '../../services/consts';
import { tokenHeader, getUserToken } from "../../services/user-service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const apiEndPoint = sendMailApi;
// const trackMailApiEndPoint = trackMailApi;

var TemplateModal = (props) => {
    const [htmlBody, setHtmlBody] = useState('');
    const [selectModal,setModal] = useState({value:true});
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [isModalOpen, setModalStatus] = useState(false);
    // const trackById = trackMailApiEndPoint + '/' + props.prospectID().id + '/photo/border.jpg';
    // console.log("TemplateModal", props);

    // console.log("Template By ID" + props.showTemplate().templateById.slug);
    // console.log("prospect ID", props.prospectID().id,props.prospectID().email);
    var sendMail = (e) => {
        // const trackById = trackMailApiEndPoint + '/' + props.prospectID().id + '/photo/border.jpg';
        // console.log("trackById", trackById);
    
        e.preventDefault();
        let methodType = 'post';
        var sendObj = {
            id: props.showTemplate().templateById.id,
            prospect: props.prospectID().id,
            currentUser: props.prospectID().currentUser,
            data: htmlBody == "" ? props.showTemplate().templateById.htmlBody + props.trackMail : htmlBody + props.trackMail
        }
        fetch(apiEndPoint, {
            method: methodType,
            body: JSON.stringify(sendObj),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                [tokenHeader]: getUserToken()
            }
        }).then((result) => {
            // console.log("result", result);
            props.visibileTemplateModal(false);
            toast.success(result.msg);
            setHtmlBody('');
        })
    }

    return (
        <div style={{ display: "flex" }}>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Modal show={props.templateStatus().templateShow} onHide={() => setModalStatus(false)} size="lg">
                <Modal.Header>
                    <Button style={{ marginLeft: "auto" }} className="float-right" color="danger" onClick={() => {
                        props.visibileTemplateModal(false);
                        // setModal({value:true})
                    }}><i className="mdi mdi-close-circle"></i></Button>
                </Modal.Header>
                <Modal.Body>
                    {/* <div onClick={(e)=>setModal({value:false})}> */}
                    <TemplateEditor trackMail={props.trackMail} showTemplateId={props.showTemplate().templateById} showTemplate={props.showTemplate().templateById.htmlBody} prospectId={props.prospectID().id} showContent={(contentData)=>{setHtmlBody(contentData)}} />
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <Button color="secondary" onClick={() => {
                        props.visibileTemplateModal(false);
                        setHtmlBody('')
                        // setModal({value:true})
                    }}>
                        Cancel
                </Button>
                {/* disabled={selectModal.value} */}
                    <Button color="primary" onClick={sendMail}>
                        Send
                </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default TemplateModal;